import React from "react";
import AdminProductCategoriesComp from "../../components/Admin/AdminProductCategories";

export default function AdminProductCategoriesPage() {
  return <AdminProductCategoriesComp />;
}